export const Color = {
  blue: "#002da0",
  white: "#ffffff",
  black: "#000000",
  grey: "#2b333e",
  light_grey: "#ebebeb",
}
